import { getCachedMe, setCachedMe } from "../../utils/auth-storage.js"
import { showPageNotFound } from "../../utils/common.js"

export const isBlocked = (id: string):boolean => !!getCachedMe()?.user?.blockList?.includes(id)

export const isBlockedUserPage = (id: string):boolean => {
    const blocked:boolean = isBlocked(id)
    if (blocked) showPageNotFound()
    return blocked
}

export const updateBlockList = (id: string) => {
    const me = getCachedMe()
    if (me?.user?.blockList) {
        if (!me.user.blockList.includes(id)) {
            me.user.blockList.push(id);
            setCachedMe(JSON.stringify(me));
        }
    }
}
